<form (submit)="submit(form)" [formGroup]="form">
	<h1 mat-dialog-title>{{'emailParcelLabelView.title' | translate}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start">
			<app-email-input-with-chips [label]="'emailParcelLabelView.recipientLabel' | translate" [parentForm]="form">
			</app-email-input-with-chips>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>{{'emailParcelLabelView.subjectLabel' | translate}}</mat-label>
				<input [formControlName]="'subject'" matInput/>
				<mat-error>
					{{'emailParcelLabelView.subjectLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field fxLayout="column" fxLayoutAlign="stretch">
				<mat-label>{{'emailParcelLabelView.messageLabel' | translate}}</mat-label>
				<textarea [formControlName]="'message'" mat-autosize matInput></textarea>
				<mat-error>
					{{'emailParcelLabelView.messageLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field *ngIf="data?.viewType == 'TABLE'" appearance="none">
				<div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="10px">
					<label>
						{{'emailParcelLabelView.fileFormatLabel' | translate}}:
					</label>
					<input matInput class="display-none"/>
					<mat-radio-group [formControlName]="'fileFormat'"							 
									 aria-label="Select file format" fxLayoutGap="10px grid"
									 [value]="PDF"
									 layout="row">
						<mat-radio-button [checked]="true" color="primary" value="{{parcelAttachmentType.PDF}}">PDF</mat-radio-button>
						<mat-radio-button color="primary" value="{{parcelAttachmentType.CSV}}">CSV</mat-radio-button>
					</mat-radio-group>
				</div>

			</mat-form-field>			
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			{{'emailParcelLabelView.cancelButton' | translate}}
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			{{'emailParcelLabelView.sendButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
